import { Dialog } from "@material-ui/core"
import dynamic from "next/dynamic"
import styled from "styled-components"
import loader from "../../public/animation/loader.json"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledDialog = styled(Dialog)`
  .MuiBackdrop-root {
    backdrop-filter: none;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .MuiDialog-paper {
    box-shadow: none;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
    background-color: #fff;
    border-radius: 50%;
    overflow: visible;
  }
`

const StyledLottie = styled(Lottie)`
  width: 250px;
  height: 250px;
`

type Props = {
  isOpen: boolean
}
const LoaderPopup = ({ isOpen }: Props) => (
  // mui dialog with no close buttons and only lottie animation.
  <StyledDialog open={isOpen} aria-label="טעינה....">
    <StyledLottie animationData={loader} />
  </StyledDialog>
)

export default LoaderPopup
